import React from "react";

import editIcon from "images/icons/invite/edit.svg";
import deleteIcon from "images/icons/invite/delete.svg";

import { usePolicyPlanCustomRecordTemplateContext } from "../../../../contexts/PolicyPlanCustomRecordTemplateContext";

export default function Actions({ row }) {
  const { dispatch, actions } = usePolicyPlanCustomRecordTemplateContext();

  const editTemplate = (e, row) => {
    actions.showEditForm(dispatch, row);
  };

  const deleteTemplate = (e, row) => {
    swal(
      {
        title: "",
        text: "Do you want to delete this custom service?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.delete(dispatch, row.id);
        }
      }
    );
  };

  return (
    <div>
      <a onClick={(e) => editTemplate(e, row)} className="mr10">
        <img src={editIcon} />
      </a>
      {row.attributes.id != "0" && (
        <a onClick={(e) => deleteTemplate(e, row)}>
          <img src={deleteIcon} />
        </a>
      )}
    </div>
  );
}
